import * as _ from 'lodash';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpEventType } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export enum FileQueueStatus { Pending, Success, Error, Progress }

export class FileQueueObject {
	public file: any;
	public status: FileQueueStatus = FileQueueStatus.Pending;
	public progress: number = 0;
	public request!: Subscription;
	public response!: HttpResponse<any> | HttpErrorResponse;

	public uploaded_name!: string;
	public uploaded_content_type!: string;
	public uploaded_url!: string;
	public uploaded_size!: string;

	public temp_name!: string;
	public temp_content_type!: string;
	public temp_url!: string;
	public temp_size!: string;
	public s3_url!: string;

	constructor(fileData: any) {
		this.file = fileData.file;
		this.temp_name = fileData.temp_name;
		this.temp_content_type = fileData.temp_content_type;
		this.temp_url = fileData.temp_url;
		this.temp_size = fileData.temp_size;
		this.s3_url = fileData.s3_url;
	}

	public upload = () => { /* set in service */ };
	public cancel = () => { /* set in service */ };
	public remove = () => { /* set in service */ };

	public isPending = () => this.status === FileQueueStatus.Pending;
	public isSuccess = () => this.status === FileQueueStatus.Success;
	public isError = () => this.status === FileQueueStatus.Error;
	public inProgress = () => this.status === FileQueueStatus.Progress;
	public isUploadable = () => this.status === FileQueueStatus.Pending || this.status === FileQueueStatus.Error;

}

@Injectable({
	providedIn: 'root'
})
export class FileuploadService {
	/* public url: string = environment.APPT_API_URL + 'api/mailgun/upload_attachment'; */
	private _queue: BehaviorSubject<FileQueueObject[]>;
	private _files: FileQueueObject[] = [];

	constructor(private http: HttpClient) {
		this._queue = <BehaviorSubject<FileQueueObject[]>>new BehaviorSubject(this._files);
	}

	public get queue() {
		return this._queue.asObservable();
	}

	public onCompleteItem(queueObj: FileQueueObject, response: any): any {
		return { queueObj, response };
	}

	public addToQueue(data: any) {
		_.each(data, (fileData: any) => this._addToQueue(fileData));
	}

	public clearQueue() {
		this._files = [];
		this._queue.next(this._files);
	}

	public uploadAll() {
		_.each(this._files, (queueObj: FileQueueObject) => {
			if (queueObj.isUploadable()) {
				this._upload(queueObj);
			}
		});
	}

	private _addToQueue(fileData: any) {
		const queueObj = new FileQueueObject(fileData);
		queueObj.upload = () => this._upload(queueObj);
		queueObj.remove = () => this._removeFromQueue(queueObj);
		queueObj.cancel = () => this._cancel(queueObj);
		this._files.push(queueObj);
		this._queue.next(this._files);
	}

	private _removeFromQueue(queueObj: FileQueueObject) {
		_.remove(this._files, queueObj);
	}

	private _upload(queueObj: FileQueueObject) {
		/* const form = new FormData();
		form.append('file', queueObj.file, queueObj.file.name);
		form.append('destination', "MailAttachments"); */
		const req = new HttpRequest('PUT', queueObj.s3_url, queueObj.file, {
			reportProgress: true
		});

		queueObj.request = this.http.request(req).subscribe({
			next: (event: any) => {
				if (event.type === HttpEventType.UploadProgress) {
					this._uploadProgress(queueObj, event);
				} else if (event instanceof HttpResponse) {
					this._uploadComplete(queueObj, event);
				}
			}, error: (err: HttpErrorResponse) => {
				if (err.error instanceof Error) {
					this._uploadFailed(queueObj, err);
				} else {
					this._uploadFailed(queueObj, err);
				}
			}
		});
		return queueObj;
	}

	private _cancel(queueObj: FileQueueObject) {
		queueObj.request.unsubscribe();
		queueObj.progress = 0;
		queueObj.status = FileQueueStatus.Pending;
		this._queue.next(this._files);
	}

	private _uploadProgress(queueObj: FileQueueObject, event: any) {
		const progress = Math.round(100 * event.loaded / event.total);
		queueObj.progress = progress;
		queueObj.status = FileQueueStatus.Progress;
		this._queue.next(this._files);
	}

	private _uploadComplete(queueObj: FileQueueObject, response: HttpResponse<any>) {
		queueObj.progress = 100;
		queueObj.status = FileQueueStatus.Success;
		queueObj.response = response;
		this._queue.next(this._files);
		this.onCompleteItem(queueObj, response.body);
	}

	private _uploadFailed(queueObj: FileQueueObject, response: HttpErrorResponse) {
		queueObj.progress = 0;
		queueObj.status = FileQueueStatus.Error;
		queueObj.response = response;
		this._queue.next(this._files);
	}
}